"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ["ATS", "ATS Coupe", "ATS Sedan", "CTS", "CTS Coupe", "CTS Sedan", "DTS", "DeVille", "Escalade EXT", "SRX", "STS", "STS-V", "Seville", "XT5", "XTS"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/fake-vehicle-apis/lib/models-cadillac.js
// module id = 112
// module chunks = 0